<script setup>
/* eslint-disable */
import { onMounted, onBeforeUnmount, ref, watch, onBeforeMount, onUnmounted, nextTick } from "vue";
import { useRouter } from 'vue-router';
import { usePreSportsStore } from '@/stores/pre_sports';
import { useGeneralStore } from '@/stores/general';
import { useCompetitionsStore } from '@/stores/competitions';
import { usePlatformConfigurationStore } from "@/stores/platform_configuration";
import { useDateTimeSportFiltersStore } from '@/stores/date_time_sport_filters';
import { useI18n } from 'vue-i18n';
import CompetitionFixtures from '@/components/pre_sports/CompetitionFixtures.vue';
import BetBoosterComponent from '@/components/Common/BetBooster/BetBoosterComponent.vue';
import CouponsPerHour from '@/components/pre_sports/CouponsPerHour.vue';
import LiveSportOverviewFavourites from '@/components/live_sports/LiveSportOverviewFavourites.vue'
const { t } = useI18n();
const router = useRouter();
const competitionsStore = useCompetitionsStore();
const preSportsStore = usePreSportsStore();
const generalStore = useGeneralStore();
const platformConfigurationStore = usePlatformConfigurationStore();
const dateTimeSportFiltersStore = useDateTimeSportFiltersStore();

const loadMoreTrigger = ref(null);
let observer = null;

const setupIntersectionObserver = () => {
	if (observer) observer.disconnect();

	if (!loadMoreTrigger.value) {
		return;
	}

	observer = new IntersectionObserver((entries) => {
		const entry = entries[0];
		if (
			entry.isIntersecting &&
			!dateTimeSportFiltersStore.is_loading &&
			dateTimeSportFiltersStore.time_fixtures.length > 0 &&
			dateTimeSportFiltersStore.current_page < dateTimeSportFiltersStore.last_page
		) {
			dateTimeSportFiltersStore.loadMoreFixtures(router.currentRoute.value.params);
		}
	}, {
		root: null,
		rootMargin: '400px',
		threshold: 0
	});

	observer.observe(loadMoreTrigger.value);
};

onBeforeMount(() => {
	if (platformConfigurationStore.isNewPreSportsLayoutEnabled && router.currentRoute.value.name == 'pre-sports-coupons-competitions-from-to') {
		if (!dateTimeSportFiltersStore.date_from) {
			dateTimeSportFiltersStore.date_from = router.currentRoute.value.params.from;
		}
	}
})

onMounted(() => {
	if (dateTimeSportFiltersStore.sort === 'time') initTimeSort();
});

onBeforeUnmount(() => {
	dateTimeSportFiltersStore.resetStore();

	competitionsStore.emptyCompetitions();
})

onUnmounted(() => {
	if (observer) observer.disconnect();
})

watch(() => preSportsStore.preSports, (newSports, oldSports) => {
	if (oldSports.length == 0 && newSports.length > 0) {
		let selected_pre_sport = _.find(preSportsStore.preSports, {'id': Number(router.currentRoute.value.params.sport_id) });
		if (!selected_pre_sport) return;
		document.title = generalStore.getGeneral.site_name + ' - ' + selected_pre_sport.name + ' ' + t('general.competitions');
	}
})

watch(() => dateTimeSportFiltersStore.sort, (newValue) => {
	if (newValue === 'time') initTimeSort();
});

watch(loadMoreTrigger, (el) => {
	if (el) setupIntersectionObserver();
});

watch(() => dateTimeSportFiltersStore.time_fixtures.length, async (newLen, oldLen) => {
	if (oldLen === 0 && newLen > 0) {
		await nextTick();
		setupIntersectionObserver();
	}
});

const initTimeSort = async () => {
	await nextTick();
	setupIntersectionObserver();
};

</script>
<template>

<template v-if="preSportsStore.selectedPreSportId != -1">
	<BetBoosterComponent :sport_id="router.currentRoute.value.params.sport_id" :competition_id="router.currentRoute.value.params.competition_ids || router.currentRoute.value.params.competition_id" :showTitle="false" />
	
	<div v-if="dateTimeSportFiltersStore.sort == 'default'" id="Competitions" class="competetion-section">
		<CompetitionFixtures v-for="(competition, index) in dateTimeSportFiltersStore.getCompetitionsWithRegion" :key="index" :index="index" :competition="competition"/>
	</div>

	<div v-if="dateTimeSportFiltersStore.sort == 'time'" id="TOID" class="competetion-section">
		<CouponsPerHour v-for="(date, index) in dateTimeSportFiltersStore.getTimeFixtures" :key="index" :date="date" />

		<div ref="loadMoreTrigger" class="load-more-sentinel" style="height: 20px;">
			<span v-if="dateTimeSportFiltersStore.is_loading">
				<div class="lds-ring"><div></div><div></div><div></div><div></div></div>
			</span>
		</div>
	</div>
</template>

<template v-else>
	<LiveSportOverviewFavourites v-for="(sport, index) in dateTimeSportFiltersStore.favouritesFixtureBySportCompetition" :key="index" :sport_overview="sport"/>


	<!-- <CompetitionFixtures v-for="(competition, index) in dateTimeSportFiltersStore.getCompetitionsWithRegion" :key="index" :index="index" :competition="competition"/> -->
</template>

</template>
<style scoped>
@media screen and (min-width: 320px) and (max-width: 767px) {
	.dropdown-option-top {
		display: block !important;
	}

	.dropdown-option-top-2 {
		display: none !important;
	}
}

.competetion-section {
	scrollbar-width: none !important;
}

.load-more-sentinel {
	width: 100%;
	height: 50px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.lds-ring {
	display: inline-block;
	position: relative;
	width: 15px;
	height: 15px;
}

.lds-ring div {
	box-sizing: border-box;
	display: block;
	position: absolute;
	width: 15px;
	height: 15px;
	top: 2px;
	margin-right: 10px;
	border: 2px solid var(--white);
	border-radius: 50%;
	animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
	border-color: var(--white) transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
	animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
	animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
	animation-delay: -0.15s;
}

@keyframes lds-ring {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}
</style>